import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { axiosConfig } from '../../Configuration/axios/axiosConfiguration'
import UserPanelTitle from '../UserPanelTitle/UserPanelTitle'
import UserPanelEmptyAlert from '../UserPanelEmptyAlert/UserPanelEmptyAlert'
import './UserPanelSaveItem.css'
import { AiOutlineCloseCircle } from 'react-icons/ai'
import { MdOutlineRemoveShoppingCart } from 'react-icons/md'
import { TbArticleOff, TbVideoOff } from 'react-icons/tb'
import imageNotFound from '../../Assets/images/ImageNotFound.jpg'
import Swal from 'sweetalert2'
import { toast, ToastContainer } from "react-toastify";

export default function UserPanelSaveItem() {
  const [productsSave, setProductsSave] = useState([])
  const [CourseSave, setCourseSave] = useState([])
  const [BlogSave, setBlogSave] = useState([])
  useEffect(() => {
    getProductSave()
    getCourseSave()
    getBlogSave()
  }, [])

  const getProductSave = () => {
    axiosConfig('api/User/GetProductSaved').then((res) => {
      setProductsSave(res.data)
    })
  }
  const getCourseSave = () => {
    axiosConfig('api/User/GetCourseSaved').then((res) => {
      setCourseSave(res.data)
    })
  }
  const getBlogSave = () => {
    axiosConfig('api/User/GetBlogSaved').then((res) => {
      setBlogSave(res.data)
    })
  }
  const deleteProduct = (productId) => {
    Swal.fire({
      icon: 'error',
      text: 'محصول از لیست ذخیره شده ها حذف شود؟',
      confirmButtonText: "بله",
      showCancelButton: true,
      cancelButtonText:
        'خیر',
    }).then((result) => {
      if (result.isConfirmed) {
        axiosConfig.delete('api/Products/productSave/' + productId).then((res) => {
          toast.success("با موفقیت  حذف شد", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          getProductSave()
        })
      }
    })
  }
  const deleteCourse = (courseId) => {
    Swal.fire({
      icon: 'error',
      text: 'محصول از لیست ذخیره شده ها حذف شود؟',
      confirmButtonText: "بله",
      showCancelButton: true,
      cancelButtonText:
        'خیر',
    }).then((result) => {
      if (result.isConfirmed) {
        axiosConfig.delete('api/Courses/CourseSave/' + courseId).then((res) => {
          toast.success("با موفقیت  حذف شد", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          getCourseSave()
        })
      }
    })
  }
  const deleteBlog = (blogId) => {
    Swal.fire({
      icon: 'error',
      text: 'محصول از لیست ذخیره شده ها حذف شود؟',
      confirmButtonText: "بله",
      showCancelButton: true,
      cancelButtonText:
        'خیر',
    }).then((result) => {
      if (result.isConfirmed) {
        axiosConfig.delete('api/Blog/DeleteBlogSave/' + blogId).then((res) => {
          toast.success("با موفقیت  حذف شد", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          getBlogSave()
        })
      }
    })
  }
  return (
    <div className='user-save-items'>
      <div className='user-course-save'>
        <UserPanelTitle title='محصولات ذخیره شده' />
        <div className='user-save-table'>
          {
            productsSave.length != 0 ? (
              <table>
                <thead>
                  <tr>
                    <th>حذف </th>
                    <th>عکس محصول</th>
                    <th>نام محصول</th>
                    <th>قیمت</th>
                    <th>لینک</th>
                  </tr>
                </thead>
                {
                  productsSave.map((item, index) => (
                    <tbody key={index}>
                      <tr className='table-item' >
                        <td>
                          <div className='remove-item'>
                            <AiOutlineCloseCircle onClick={() => deleteProduct(item.product.id)} />
                          </div>
                        </td>
                        <td>
                          <div className='item-image'>
                            {
                              item.product.productImages.length ? (
                                <img src={
                                  axiosConfig.defaults.baseURL +
                                  "Images/ProductImage/" +
                                  item.product.id +
                                  "/" +
                                  item.product.productImages[0]
                                    .imagePath} alt={`محصول ${item.product.title}`}/>
                              ) : (
                                <img src={imageNotFound} alt={`محصول ${item.product.title}`} />
                              )
                            }
                          </div>
                        </td>
                        <td>{item.product.title}</td>
                        <td>{item.product.price}</td>
                        <td>
                          <Link to={`/product/${item.product.title}`}>
                            <button className='table-btn'>صفحه محصول</button>
                          </Link>
                        </td>
                      </tr>
                    </tbody>

                  ))
                }
              </table>
            ) : (
              <UserPanelEmptyAlert title='محصولی ذخیره نشده است' icon={<MdOutlineRemoveShoppingCart />} />
            )
          }

        </div>
        {
          productsSave.length != 0 ? (
            productsSave.map((item, index) => (
              <div className='user-order-table-responsive' key={index}>
                <table className='table-responsive-save-item' >
                  <tbody>
                    <tr className='product-tr-responsive'>
                      <th>نام محصول</th>
                      <td className='product-td'>
                        {
                          item.product.productImages.length ? (
                            <img src={
                              axiosConfig.defaults.baseURL +
                              "Images/ProductImage/" +
                              item.product.id +
                              "/" +
                              item.product.productImages[0]
                                .imagePath} alt={`محصول ${item.product.title}`} />
                          ) : (
                            <img src={imageNotFound} alt={`محصول ${item.product.title}`} />
                          )
                        }
                        <h3>{item.product.title}</h3>
                      </td>
                    </tr>
                    <tr>
                      <th>قیمت</th>
                      <td className='price-td'>{item.product.price}</td>
                    </tr>
                    <tr>
                      <th>
                        صفحه محصول
                      </th>
                      <td>
                        <Link to={`/product/${item.product.title}`}>
                          <button className='table-btn'>صفحه محصول</button>
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <th>حذف محصول</th>
                      <td>
                        <div className='remove-item'>
                          <button className='table-btn-res' onClick={() => deleteProduct(item.product.id)} >حذف محصول</button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            ))

          ) : (
            <div className='user-order-table-responsive'>
            <UserPanelEmptyAlert title='محصولی ذخیره نشده است' icon={<MdOutlineRemoveShoppingCart />} />
            </div>
          )
        }
      </div>
      <div className='user-product-save'>
        <UserPanelTitle title='دوره های ذخیره شده' />
        <div className='user-save-table'>
          {
            CourseSave.length != 0 ? (
              <table >
                <thead>
                  <tr>
                    <th>حذف</th>
                    <th>عکس دوره</th>
                    <th>نام دوره</th>
                    <th>درصد تکمیل دوره</th>
                    <th>قیمت دوره</th>
                    <th>لینک</th>
                  </tr>
                </thead>
                {

                  CourseSave.map((item, index) => (

                    <tbody key={index}>
                      <tr className='table-item'>
                        <td>
                          <div className='remove-item'>
                            <AiOutlineCloseCircle onClick={() => deleteCourse(item.course.id)} />
                          </div>
                        </td>
                        <td>
                          {
                            item.course.image != null ? (
                              <img src={
                                axiosConfig.defaults.baseURL +
                                "Images/CourseImage/" +
                                item.course.id +
                                "/" +
                                item.course.image} alt={item.course.title} />
                            ) : (
                              <img src={imageNotFound} alt={item.course.title} />
                            )
                          }
                        </td>
                        <td>{item.course.title}</td>
                        <td>{item.course.percentComplete} درصد</td>
                        <td>{item.course.price}</td>
                        <td>
                          <Link to={`/course/${item.course.title}`}>
                            <button className='table-btn'>صفحه دوره</button>
                          </Link>
                        </td>
                      </tr>
                    </tbody>

                  ))
                }
              </table>
            ) :
              (<UserPanelEmptyAlert title='دوره ای ذخیره نشده است' icon={<TbVideoOff />} />)
          }

        </div>

        {
          CourseSave.length != 0 ? (
            CourseSave.map((item, index) => (
              <div className='user-order-table-responsive' key={index}>
                <table>
                  <tbody>
                    <tr className='product-tr-responsive'>
                      <th>نام دوره</th>
                      <td className='product-td'>
                        {
                          item.course.image != null ? (
                            <img src={
                              axiosConfig.defaults.baseURL +
                              "Images/CourseImage/" +
                              item.course.id +
                              "/" +
                              item.course.image} alt="" />
                          ) : (
                            <img src={imageNotFound} alt="" />
                          )
                        }
                        <h3>{item.course.title}</h3>
                      </td>
                    </tr>
                    <tr>
                      <th>قیمت</th>
                      <td className='price-td'>{item.course.price}</td>
                    </tr>
                    <tr>
                      <th>
                        درصد تکمیل دوره
                      </th>
                      <td>
                        {item.course.percentComplete} درصد
                      </td>
                    </tr>
                    <tr>
                      <th>لینک</th>
                      <td>
                        <Link to={`/course/${item.course.title}`}>
                          <button className='table-btn'>صفحه دوره</button>
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <th>حذف دوره</th>
                      <td>
                        <div className='remove-item'>
                          <button className='table-btn-res' onClick={() => deleteCourse(item.course.id)} >حذف دوره</button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            ))

          ) : (
            <div className='user-order-table-responsive'>
            <UserPanelEmptyAlert title='دوره ای ذخیره نشده است' icon={<TbVideoOff />} />
            </div>
          )
        }

      </div>



      <div className='user-blog-save'>
        <UserPanelTitle title='مقاله های ذخیره شده' />
        <div className='user-save-table'>
          {
            BlogSave.length != 0 ? (<table >
              <thead>
                <tr>
                  <th>حذف </th>
                  <th>عکس مقاله</th>
                  <th>نام مقاله</th>
                  <th>تاریخ مقاله</th>
                  <th>لینک</th>
                </tr>
              </thead>
              {
                BlogSave.map((item, index) => (
                  <tbody key={index}>
                    <tr className='table-item' >
                      <td>
                        <div className='remove-item'>
                          <AiOutlineCloseCircle onClick={() => deleteBlog(item.blog.id)} />
                        </div>
                      </td>
                      <td>
                        <div className='item-image'>
                          {
                            item.blog.image != null ? (
                              <img src={
                                axiosConfig.defaults.baseURL +
                                "Images/BlogImage/" +
                                item.blog.id +
                                "/" +
                                item.blog.image} alt="" />
                            ) : (
                              <img src={imageNotFound} alt="" />
                            )
                          }
                        </div>
                      </td>
                      <td>{item.blog.title}</td>
                      <td>
                        {
                          new Date(item.blog.registerDate).toLocaleDateString('fa-IR')
                        }
                      </td>
                      <td>
                        <Link to={`/article/${item.blog.title}`}>
                          <button className='table-btn'>صفحه مقاله</button>
                        </Link>
                      </td>
                    </tr>
                  </tbody>

                ))
              }
            </table>)
              :
              (
              <UserPanelEmptyAlert title='مقاله ای ذخیره نشده است' icon={<TbArticleOff />} />
              )
          }

        </div>

        {
          BlogSave.length != 0 ? (
            BlogSave.map((item, index) => (
              <div className='user-order-table-responsive'>
                <table>
                  <tbody>
                    <tr className='product-tr-responsive'>
                      <th>نام مقاله</th>
                      <td className='product-td'>
                        {
                          item.blog.image != null ? (
                            <img src={
                              axiosConfig.defaults.baseURL +
                              "Images/BlogImage/" +
                              item.blog.id +
                              "/" +
                              item.blog.image} alt="" />
                          ) : (
                            <img src={imageNotFound} alt="" />
                          )
                        }
                        <h3>{item.blog.title}</h3>
                      </td>
                    </tr>
                    <tr>
                      <th>تاریخ انتشار</th>
                      <td className='price-td'>
                        {
                          new Date(item.blog.registerDate).toLocaleDateString('fa-IR')
                        }
                      </td>
                    </tr>
                    <tr>
                      <th>
                        لینک
                      </th>
                      <td>
                        <Link to={`/article/${item.blog.title}`}>
                          <button className='table-btn'>صفحه مقاله</button>
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <th>حذف</th>
                      <td>
                      <div className='remove-item'>
                          <button className='table-btn-res' onClick={() => deleteBlog(item.blog.id)} >حذف مقاله</button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            ))

          ) : (
            <div className='user-order-table-responsive'>
            <UserPanelEmptyAlert title='مقاله ای ذخیره نشده است' icon={<TbArticleOff />} />
            </div>
          )
        }

      </div>
      <ToastContainer />
    </div>

  )
}
